import { createContext, useContext, useEffect, useState } from "react";
import { portalApi } from "@/lib/portalApi";

const Ctx = createContext(null);
export const useVendorPortal = () => useContext(Ctx);

export function VendorPortalProvider({ children }) {
  const [vendorUser, setVendorUser] = useState(null);
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const tok = localStorage.getItem("reason_vendor_token");
      if (tok) {
        try {
          const me = (await portalApi.get("/vendor-portal/me")).data;
          setVendorUser(me.vendor_user);
          setVendor(me.vendor);
        } catch (e) {
          localStorage.removeItem("reason_vendor_token");
        }
      }
      setLoading(false);
    })();
  }, []);

  const login = async (email, password) => {
    const res = (await portalApi.post("/vendor-portal/login", { email, password })).data;
    localStorage.setItem("reason_vendor_token", res.access_token);
    setVendorUser(res.vendor_user);
    setVendor(res.vendor);
    return res;
  };

  const logout = () => {
    localStorage.removeItem("reason_vendor_token");
    setVendorUser(null);
    setVendor(null);
  };

  return (
    <Ctx.Provider value={{ vendorUser, vendor, loading, login, logout }}>
      {children}
    </Ctx.Provider>
  );
}
